import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HelperService } from 'src/app/services/helper.service';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LeftSideBarComponent } from '../leftsidebar/leftsidebar.component';

@Component({
  selector: 'public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NavbarComponent,
    LeftSideBarComponent
  ]
})
export class PublicLayoutComponent
{
  constructor
    (
      public helperService: HelperService
    )
  {
  }

  ngOnInit()
  {
    this.checkScreenSize();
  }

  @HostListener('window:resize')
  onResize()
  {
    const wasMobile = this.helperService.isMobile;
    this.checkScreenSize();
    // Close sidebar when switching back to desktop
    if (!this.helperService.isMobile && wasMobile) {
      this.helperService.leftSideMenuOpen = false;
    }
  }

  private checkScreenSize()
  {
    this.helperService.isMobile = window.innerWidth <= 991;
  }
}
